import { render, staticRenderFns } from "./Explore_the_world.vue?vue&type=template&id=e3b558d0&scoped=true"
import script from "./Explore_the_world.vue?vue&type=script&lang=js"
export * from "./Explore_the_world.vue?vue&type=script&lang=js"
import style0 from "./Explore_the_world.vue?vue&type=style&index=0&id=e3b558d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b558d0",
  null
  
)

export default component.exports